"use strict";

// https://www.w3.org/WAI/ARIA/apg/patterns/accordion/examples/accordion
const baseTemplate = document.createElement("template");
baseTemplate.innerHTML = require("./template");
const ARIA_EXPANDED = "aria-expanded";

const typography = require("!!css-loader!../../tokens/typography.css").default;
const table = require("!!css-loader!../table/style/index.css").default;

// for some reason, the toggle on click is different from the programmatic toggle
function _toggleOnClick () {
    const isOpen = this.accordion.hasAttribute("open");
    if (isOpen === false) {
        this.accordion.removeAttribute("open");
        this.accordionContent.removeAttribute("hidden")
        this.accortionTitle.setAttribute(ARIA_EXPANDED, "true");
    } else {

        this.accordion.setAttribute("open", "");
        this.accordionContent.setAttribute("hidden", "")
        this.accortionTitle.setAttribute(ARIA_EXPANDED, "false");
    }
}

class Element extends HTMLElement {
    constructor(template) {
        super();

        this.root = this.attachShadow({ mode: "open" });

        /**
         * Applying styles inside the shadow DOM:
         * @see https://developer.mozilla.org/en-US/docs/Web/API/Web_components/Using_shadow_DOM#applying_styles_inside_the_shadow_dom
         */
        const typographySheet = new CSSStyleSheet();
        typographySheet.replaceSync(typography);
        const tableSheet = new CSSStyleSheet();
        tableSheet.replaceSync(table);
        this.root.adoptedStyleSheets = [typographySheet, tableSheet];

        const content = template ? template.content.cloneNode(true) : baseTemplate.content.cloneNode(true);
        this.root.appendChild(content);
        this.accortionTitle = this.root.querySelector('.accordion-title');
        const now = Date.now();
        const sectionId = "section-" + now;
        this.accortionTitle.setAttribute("aria-controls", sectionId);
        this.accordion = this.root.querySelector('.swiftref-accordion')
        this.accordionContent = this.root.querySelector('.accordion-content');
        this.accordionContent.id = sectionId;
        this.accordionContent.setAttribute("aria-labelledby", "accordion-" + now);
        this.toggle = this.toggle.bind(this);
        this.accortionTitle.addEventListener("click", _toggleOnClick.bind(this));
        this.initSlots();


        // proxy the click event outside the Shadow DOM
        // this.accordion.addEventListener("click", function (event) {
        //     this.dispatchEvent(new CustomEvent("click", {
        //         detail: {
        //             originalTarget: event.target
        //         },
        //         bubbles: true,
        //         composed: true
        //     }));
        // }.bind(this));
    }

    get expanded() {
        return this.hasAttribute("expanded");
    }
    set expanded(value) {
        this.setAttribute("expanded", "");
    }


    static get observedAttributes() {
        return ["expanded"];
    }


    initSlots () {

        if (this.innerHTML) {
            const slot = this.querySelector('[slot="title"]');
            this.accortionTitle.textContent = slot.innerText;
            this.removeChild(slot);
        }
        // for (const child of this.childNodes) {
            // this.accordionContent.appendChild(child);
        // }

        this.open();

    }


    renderAttribute (name, value) {
        switch (name) {
            case "expanded":
                if (this.expanded) {
                    this.accordion.setAttribute("open", "");
                    this.accordionContent.removeAttribute("hidden");
                    this.accortionTitle.setAttribute(ARIA_EXPANDED, "true");
                } else {
                    this.accordion.removeAttribute("open");
                    this.accordionContent.setAttribute("hidden", "")
                    this.accortionTitle.setAttribute(ARIA_EXPANDED, "false");
                }
                break;
            default:
                break;
        }
    }

    toggle() {
        if (this.hasAttribute("expanded")) {
            this.removeAttribute("expanded");
        } else {
            this.setAttribute("expanded", "");
        }
    }

    close() {
        if (this.hasAttribute("expanded")) {
            this.removeAttribute("expanded");
        }
    }
    open() {
        if (!this.hasAttribute("expanded")) {
            this.setAttribute("expanded", "");
        }
    }


    connectedCallback() {
        this.open();
    }



    attributeChangedCallback(name, oldVal, newVal) {
        this.renderAttribute(name, newVal);
    }




}

window.customElements.define("swiftref-accordion", Element);

module.exports = Element;
